// extracted by mini-css-extract-plugin
export default {"subheading":"Subheading_subheading__CiYel"};